module.exports = {
  store: 'http://52.56.227.23:6377'
}


// WEBPACK FOOTER //
// ./src/web/web.config.js